```vue
<template>
  <section class="branchen-section">

    <v-container fluid class="pa-0">

      <div class="branchen-image-wrapper">

        <!-- =====================================================
             HINTERGRUNDBILD
        ====================================================== -->

        <v-img
          :src="kitchenImage"
          alt="Professionelle Großküche mit verschiedenen Einsatzbereichen"
          class="branchen-image"
          cover
        />


        <!-- =====================================================
             INTERAKTIVE BRANCHEN-BUTTONS
        ====================================================== -->

        <v-btn
          v-for="branch in branches"
          :key="branch.name"
          :to="branch.link"
          class="branch-button"
          :class="branch.class"
          variant="flat"
          rounded="pill"
          :aria-label="`Mehr Informationen zu ${branch.name}`"
        >

          <!-- Icon -->
          <div class="branch-icon">

            <v-icon size="30">
              {{ branch.icon }}
            </v-icon>

          </div>


          <!-- Text -->
          <span class="branch-text">
            {{ branch.name }}
          </span>


          <!-- Pfeil -->
          <v-icon
            class="branch-arrow"
            size="24"
          >
            mdi-chevron-right
          </v-icon>

        </v-btn>

      </div>

    </v-container>

  </section>
</template>


<script setup>

// ============================================================
// BILD
// ============================================================

import kitchenImage from '../assets/BrancheKueche.png'


// ============================================================
// BRANCHEN
// ============================================================
// Die Links entsprechen exakt den Routen aus router.js.
// ============================================================

const branches = [

  {
    name: 'Gastronomie',
    icon: 'mdi-silverware-fork-knife',
    link: '/gastronomie',
    class: 'branch-gastronomie'
  },

  {
    name: 'Gemeinschaftsverpflegung',
    icon: 'mdi-chef-hat',
    link: '/gemeinschaftsverpflegung',
    class: 'branch-gemeinschaft'
  },

  {
    name: 'Gebäudereinigung',
    icon: 'mdi-broom',
    link: '/gebaeudereinigung',
    class: 'branch-reinigung'
  },

  {
    name: 'Kindergarten',
    icon: 'mdi-human-child',
    link: '/kindergarten',
    class: 'branch-kindergarten'
  },

  {
    name: 'Pflege',
    icon: 'mdi-wheelchair-accessibility',
    link: '/pflege',
    class: 'branch-pflege'
  }

]

</script>


<style scoped>

/* ==========================================================
   GRUNDSTRUKTUR
========================================================== */

.branchen-section {
  width: 100%;
  overflow: hidden;
}


.branchen-image-wrapper {
  position: relative;

  width: 100%;

  aspect-ratio: 16 / 9;

  overflow: hidden;

  background: #f2f2f2;
}


/* ==========================================================
   HINTERGRUNDBILD
========================================================== */

.branchen-image {
  position: absolute;

  inset: 0;

  width: 100%;
  height: 100%;
}


/* ==========================================================
   ALLGEMEINE BUTTONS
========================================================== */

.branch-button {
  position: absolute !important;

  height: 64px !important;

  min-width: 250px !important;

  padding: 0 18px 0 0 !important;

  display: flex !important;

  align-items: center !important;

  justify-content: flex-start !important;

  background: rgba(245, 245, 245, 0.92) !important;

  color: #202020 !important;

  border: 2px solid rgba(255, 255, 255, 0.95);

  box-shadow:
    0 4px 15px rgba(0, 0, 0, 0.14),
    inset 0 0 0 1px rgba(255, 255, 255, 0.5);

  backdrop-filter: blur(4px);

  -webkit-backdrop-filter: blur(4px);

  transition:
    background-color 0.25s ease,
    color 0.25s ease,
    transform 0.25s ease,
    box-shadow 0.25s ease;

  text-transform: none;

  letter-spacing: normal;

  z-index: 5;
}


/* ==========================================================
   ICON
========================================================== */

.branch-icon {
  width: 62px;

  height: 62px;

  flex: 0 0 62px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 50%;

  background: rgba(230, 230, 230, 0.95);

  transition:
    background-color 0.25s ease,
    color 0.25s ease;
}


.branch-button .v-icon {
  color: #303030;
}


/* ==========================================================
   TEXT
========================================================== */

.branch-text {
  flex: 1;

  min-width: 0;

  margin-left: 15px;

  font-size: 20px;

  font-weight: 600;

  line-height: 1.2;

  white-space: nowrap;

  transition: color 0.25s ease;
}


/* ==========================================================
   PFEIL
========================================================== */

.branch-arrow {
  margin-left: 10px;

  flex: 0 0 auto;

  transition:
    transform 0.25s ease,
    color 0.25s ease;
}


/* ==========================================================
   HOVER
========================================================== */

.branch-button:hover {
  background: rgb(114, 184, 42) !important;

  color: #ffffff !important;

  transform:
    translateY(-3px)
    scale(1.02);

  box-shadow:
    0 8px 24px rgba(114, 184, 42, 0.35);

  opacity: 1 !important;
}


.branch-button:hover .branch-icon {
  background: #ffffff;
}


.branch-button:hover .v-icon {
  color: rgb(114, 184, 42);
}


.branch-button:hover .branch-arrow {
  color: #ffffff;

  transform: translateX(4px);
}


.branch-button:hover .branch-text {
  color: #ffffff;
}


/* ==========================================================
   DESKTOP POSITIONEN
========================================================== */


/* Gastronomie */

.branch-gastronomie {
  left: 5%;

  top: 57%;
}


/* Gemeinschaftsverpflegung */

.branch-gemeinschaft {
  left: 38%;

  top: 20%;
}


/* Gebäudereinigung */

.branch-reinigung {
  right: 4%;

  top: 13%;
}


/* Kindergarten */

.branch-kindergarten {
  left: 41%;

  top: 68%;
}


/* Pflege */

.branch-pflege {
  right: 5%;

  top: 60%;
}


/* ==========================================================
   TABLET
   769px – 1200px
========================================================== */

@media (max-width: 1200px) {

  .branch-button {
    height: 56px !important;

    min-width: 215px !important;

    padding-right: 14px !important;
  }


  .branch-icon {
    width: 54px;

    height: 54px;

    flex-basis: 54px;
  }


  .branch-text {
    margin-left: 12px;

    font-size: 17px;
  }


  .branch-button .v-icon {
    font-size: 24px;
  }


  .branch-arrow {
    margin-left: 7px;
  }

}


/* ==========================================================
   MOBILE
   Bis 768px
========================================================== */

@media (max-width: 768px) {

  /*
   * Auf Mobil wird die 16:9-Darstellung aufgehoben.
   * Dadurch erhalten die fünf Buttons ausreichend Platz.
   */

  .branchen-image-wrapper {
    width: 100%;

    height: 760px;

    min-height: 760px;

    aspect-ratio: auto;

    overflow: hidden;
  }


  /*
   * Hintergrundbild
   */

  .branchen-image {
    position: absolute;

    inset: 0;

    width: 100%;

    height: 100%;
  }


  /*
   * Alle Buttons werden mittig angeordnet.
   */

  .branch-button {
    left: 50% !important;

    right: auto !important;

    width: calc(100% - 32px) !important;

    max-width: 430px;

    min-width: 0 !important;

    height: 58px !important;

    padding: 0 12px 0 0 !important;

    transform: translateX(-50%) !important;
  }


  /*
   * Icon
   */

  .branch-icon {
    width: 54px;

    height: 54px;

    flex: 0 0 54px;
  }


  .branch-button .v-icon {
    font-size: 24px !important;
  }


  /*
   * Text
   */

  .branch-text {
    margin-left: 11px;

    font-size: clamp(14px, 4vw, 18px);

    font-weight: 600;

    line-height: 1.2;

    white-space: nowrap;

    overflow: hidden;

    text-overflow: ellipsis;
  }


  /*
   * Pfeil
   */

  .branch-arrow {
    margin-left: 8px;

    font-size: 22px !important;

    flex: 0 0 auto;
  }


  /*
   * Positionen Mobile
   */

  .branch-gemeinschaft {
    top: 12%;
  }


  .branch-reinigung {
    top: 29%;
  }


  .branch-gastronomie {
    top: 46%;
  }


  .branch-kindergarten {
    top: 63%;
  }


  .branch-pflege {
    top: 80%;
  }


  /*
   * Touch/Hover
   */

  .branch-button:hover {
    transform:
      translateX(-50%)
      translateY(-2px)
      scale(1.01) !important;
  }

}


/* ==========================================================
   KLEINE SMARTPHONES
   Bis 480px
========================================================== */

@media (max-width: 480px) {

  .branchen-image-wrapper {
    height: 720px;

    min-height: 720px;
  }


  .branch-button {
    width: calc(100% - 24px) !important;

    max-width: none;

    height: 54px !important;

    padding-right: 10px !important;
  }


  .branch-icon {
    width: 50px;

    height: 50px;

    flex: 0 0 50px;
  }


  .branch-button .v-icon {
    font-size: 22px !important;
  }


  .branch-text {
    margin-left: 9px;

    font-size: 15px;
  }


  .branch-arrow {
    margin-left: 5px;

    font-size: 20px !important;
  }


  /*
   * Gleichmäßige Verteilung
   */

  .branch-gemeinschaft {
    top: 11%;
  }


  .branch-reinigung {
    top: 29%;
  }


  .branch-gastronomie {
    top: 47%;
  }


  .branch-kindergarten {
    top: 65%;
  }


  .branch-pflege {
    top: 83%;
  }

}


/* ==========================================================
   SEHR KLEINE SMARTPHONES
   Bis 360px
========================================================== */

@media (max-width: 360px) {

  .branchen-image-wrapper {
    height: 680px;

    min-height: 680px;
  }


  .branch-button {
    width: calc(100% - 16px) !important;

    height: 50px !important;

    padding-right: 8px !important;
  }


  .branch-icon {
    width: 46px;

    height: 46px;

    flex: 0 0 46px;
  }


  .branch-button .v-icon {
    font-size: 20px !important;
  }


  .branch-text {
    margin-left: 8px;

    font-size: 14px;
  }


  .branch-arrow {
    margin-left: 3px;

    font-size: 19px !important;
  }

}


/* ==========================================================
   TOUCH-GERÄTE
========================================================== */

@media (hover: none) and (pointer: coarse) {

  .branch-button:hover {
    background: rgba(245, 245, 245, 0.92) !important;

    color: #202020 !important;

    box-shadow:
      0 4px 15px rgba(0, 0, 0, 0.14),
      inset 0 0 0 1px rgba(255, 255, 255, 0.5);

    opacity: 1 !important;
  }


  .branch-button:hover .branch-icon {
    background: rgba(230, 230, 230, 0.95);
  }


  .branch-button:hover .v-icon {
    color: #303030;
  }


  .branch-button:hover .branch-arrow {
    color: inherit;

    transform: none;
  }


  .branch-button:hover .branch-text {
    color: inherit;
  }

}

</style>
```

### Was jetzt korrigiert ist

Der entscheidende Bereich lautet jetzt vollständig:

```vue
.branch-arrow {
  margin-left: 10px;

  flex: 0 0 auto;

  transition:
    transform 0.25s ease,
    color 0.25s ease;
}

